// extracted by mini-css-extract-plugin
export var label = "_at-1";
export var reminder = "_at-0";